<div class="profile-circle" [style.background-color]="color">{{ letter }}</div>